import * as React from 'react';
const SvgLoading = () =>
  /* @__PURE__ */ React.createElement(
    'svg',
    { width: 24, height: 24, fill: 'none' },
    /* @__PURE__ */ React.createElement('path', {
      fill: 'currentColor',
      fillRule: 'evenodd',
      d: 'M12 3.667a8.333 8.333 0 1 0 0 16.666 8.333 8.333 0 0 0 0-16.666M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12',
      clipRule: 'evenodd',
      opacity: 0.4,
    }),
    /* @__PURE__ */ React.createElement('path', {
      fill: 'currentColor',
      fillRule: 'evenodd',
      d: 'M11.166 2.833c0-.46.373-.833.833-.833a10 10 0 0 1 10 10 .833.833 0 1 1-1.666 0 8.333 8.333 0 0 0-8.334-8.333.833.833 0 0 1-.833-.834',
      clipRule: 'evenodd',
    }),
  );
export default SvgLoading;
